import { useContext } from 'react';
import { useRouter } from 'next/router';
import { useMutation } from '@tanstack/react-query';

import recreateAccessToken from '@/api/auth/recreateAccessToken.endpoint';
import setAuthenticatedUser from '@/modules/auth/setAuthenticatedUser';
import { GlobalContext } from '@/shared/GlobalContext/GlobalContext';
import emailVerificationConstants from '@/v2/domains/Auth/constants/emailVerificationConstants';

export default function useUnlockVerifiedSessionMutation() {
  const router = useRouter();
  const globalContext = useContext(GlobalContext);

  return useMutation({
    mutationFn: async () => {
      const response = await recreateAccessToken();

      await setAuthenticatedUser({
        accessToken: response.token,
        context: globalContext,
      });
    },
    onSuccess: () =>
      router.push(emailVerificationConstants.verifiedRedirectPath),
    meta: {
      notification: {
        error: "We couldn't open your account. Please reload the page.",
      },
    },
  });
}
